import { useEffect, useState } from "react";
import { Card, CardBody, CardHeader } from "../../../components/card/card";
import ModalTel3SelectUk from "../modal/modalSelectUk";
import { dataTel3DelPart, dataTel3EditEval, dataTel3EditLinkRelink, dataTel3PostNewPartUk, dataTel3PostNewPresetPart } from "../../../config/apiSPA";
import ModalTel3AddPart from "../modal/modalAddPart";
import ModalInfo from "../../../components/modal/modalInfo";
import ModalConfirm from "../../../components/modal/modalConfirm";
import ModalEditSelect2 from "../../../components/modal/modalEditSelect2";
import IconParticipant from "./iconPart";
import ModalEventQr from "../../../components/modal/modalEventQr";
import ModalLoadingPage from "../../../components/modal/loadingPage";
import { Link } from "react-router-dom";
import ModalResultPart from "../modal/modalResultPart";

function ParticipantContent({ data }) {
  const [modalUk, setModalUk] = useState({ show: false, trId: null });
  const [modalNewPart, setModalNewPart] = useState({ show: false });
  const [dataInPart, setDataInPart] = useState(null);
  const [modalInfo, setModalInfo] = useState({ show: false, text: "no text" });
  const [modalConfirmDel, setModalConfirmDel] = useState({ show: false, id: null });
  const [modalEditEval, setModalEditEval] = useState({ show: false, id: null });
  const [modalShowLink, setModalShowLink] = useState({ show: false, data: null });
  const [modalLoadingPage, setModalLoadingPage] = useState(false);
  const [modalResultPart, setModalResultPart] = useState({ show: false, id: null });
  const handleClickAddPart = () => {
    setModalNewPart({ show: true });
  };
  const handleClickAddPartByUk = () => {
    setModalUk({ show: true, trId: data.training.id });
  };
  const handleSubmitClickUkPart = async (e) => {
    try {
      setModalUk((a) => ({}));
      const res = await dataTel3PostNewPartUk({ id: data.id, ukPartId: e.val });
      setDataInPart(res.data);
    } catch (error) {
      setModalInfo({ show: true, text: error.message });
    }
  };
  const handleSubmitAddPart = async (e) => {
    try {
      setModalNewPart({ show: false });
      const d = e;
      d.mainId = data.id;
      const res = await dataTel3PostNewPresetPart(d);
      setDataInPart(res.data);
    } catch (error) {
      setModalInfo({ show: true, text: error.message });
    }
  };
  const handlClickDelPart = (e) => {
    setModalConfirmDel({ show: true, id: e });
  };
  const handleClickDeleteConfirm = async (e) => {
    try {
      setModalConfirmDel((a) => ({ ...a, show: false }));
      const res = await dataTel3DelPart(e);
      setDataInPart(res.data);
    } catch (error) {
      setModalInfo({ show: true, text: error.message });
    }
  };
  const handleClickEditEval = (e) => {
    setModalEditEval({ show: true, id: e });
  };
  const handleSubmitEditEval = async (e) => {
    try {
      setModalEditEval({ show: false, id: null });
      const res = await dataTel3EditEval({ partId: e.id, evalId: e.val });
      setDataInPart(res.data);
    } catch (error) {
      setModalInfo({ show: true, text: error.message });
    }
  };
  const handleClickShowLink = (e) => {
    setModalShowLink({ show: true, data: e });
  };
  const handleClickRelink = async (e) => {
    try {
      setModalLoadingPage(true);
      const res = await dataTel3EditLinkRelink({ partId: e });
      setDataInPart(res.data);
      setModalLoadingPage(false);
    } catch (error) {
      setModalInfo({ show: true, text: error.message });
    }
  };
  const handleClickDetailPart = (e) => {
    setModalResultPart({ show: true, id: e });
  };
  const iconEval = (v) => {
    if (v.signaturePath) {
      return <i className="far fa-edit mx-1"></i>;
    }
    return (
      <a onClick={() => handleClickEditEval(v.id)} className="px-1" href="#/" title="Change Evaluator">
        <i className="far fa-edit text-theme"></i>
      </a>
    );
  };
  useEffect(() => {
    setDataInPart(data);
  }, [data]);
  return (
    <>
      <Card className="mb-4">
        <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">Participant</CardHeader>
        <CardBody>
          <div className="mb-2">
            <div className="d-block d-lg-flex align-items-center">
              {dataInPart?.training.moreUk === 1 && dataInPart?.participant.length < 1 ? (
                <span onClick={handleClickAddPartByUk} className="btn btn-outline-danger me-2 mb-1">
                  <i className="fa fa-fw fa-plus"></i>
                  <span>Select UK..</span>
                </span>
              ) : null}
              <span onClick={handleClickAddPart} className="btn btn-outline-theme me-2 mb-1">
                <i className="fa fa-fw fa-plus"></i>
                <span>Add Part..</span>
              </span>
            </div>
          </div>
          {dataInPart?.participant.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-hover text-nowrap">
                <thead>
                  <tr>
                    <th className="border-top-0 pt-0 pb-2">Name</th>
                    <th className="border-top-0 pt-0 pb-2">Evaluator</th>
                    <th className="border-top-0 pt-0 pb-2">Final Score (Max:4)</th>
                    <th className="border-top-0 pt-0 pb-2">Percentage</th>
                    <th className="border-top-0 pt-0 pb-2"></th>
                  </tr>
                </thead>
                <tbody>
                  {dataInPart?.participant.map((val) => (
                    <tr key={val.id}>
                      <td className="align-middle">{val.signaturePath ? <Link onClick={() => handleClickDetailPart(val.id)}>{val.partData.nama}</Link> : val.partData.nama} </td>
                      <td className="align-middle">
                        {val.evaluator ? (
                          <>
                            {val.evaluator.nama}
                            {iconEval(val)}
                          </>
                        ) : (
                          <>
                            <i className="text-danger">Evaluator Not Found</i>
                            {iconEval(val)}
                          </>
                        )}
                      </td>
                      <td className="align-middle">{val.signaturePath ? val.finalScore : "Not Scored"}</td>
                      <td className="align-middle">{val.signaturePath ? val.percentage + " %" : "-"}</td>
                      <td className="align-middle">
                        <IconParticipant val={val} onShowLink={handleClickShowLink} onRelink={handleClickRelink} onDelete={handlClickDelPart} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p>No Data</p>
          )}
        </CardBody>
      </Card>
      <ModalTel3SelectUk
        submitClick={handleSubmitClickUkPart}
        trId={modalUk.trId}
        onHide={() => setModalUk((a) => ({ ...a, show: false }))}
        show={modalUk.show}
        options={{ title: "Unit Competency", text: "Please Select Unit Competency" }}
      />
      <ModalTel3AddPart
        submitClick={handleSubmitAddPart}
        onHide={() => setModalNewPart((a) => ({ ...a, show: false }))}
        show={modalNewPart.show}
        options={{ title: "Add Participant", text: "Enter participant details manually if the person is not in the list" }}
      />
      <ModalInfo clicked={() => setModalInfo((a) => ({ ...a, show: false }))} onHide={() => setModalInfo((a) => ({ ...a, show: false }))} theme={"danger"} text={modalInfo.text} title={"Warning !!"} show={modalInfo.show} />
      <ModalConfirm
        clicked={handleClickDeleteConfirm}
        onHide={() => setModalConfirmDel((a) => ({ ...a, show: false }))}
        show={modalConfirmDel.show}
        theme={"danger"}
        title={"Warning !!"}
        text={"Are you sure want to delete this participant ??"}
        id={modalConfirmDel.id}
      />
      <ModalEditSelect2
        selector="manpower"
        show={modalEditEval.show}
        options={{ title: "Change Evaluator", text: "Select an evaluator. Ensure the evaluator’s name is registered in the manpower data and the phone number is filled in and active on WhatsApp." }}
        id={modalEditEval.id}
        onHide={() => setModalEditEval((a) => ({ ...a, show: false }))}
        submitClick={handleSubmitEditEval}
      />
      <ModalEventQr show={modalShowLink.show} data={modalShowLink.data} onHide={() => setModalShowLink((a) => ({ ...a, show: false }))} submitClick={() => setModalShowLink((a) => ({ ...a, show: false }))} />
      <ModalLoadingPage show={modalLoadingPage} />
      <ModalResultPart show={modalResultPart.show} handleClose={() => setModalResultPart((a) => ({ ...a, show: false }))} id={modalResultPart.id} />
    </>
  );
}

export default ParticipantContent;
